import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './ProgrammableLogicController.frontend.types'

@Injectable({ providedIn: 'root' })
export class ProgrammableLogicController_get_containers_ready_for_plcService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { warehouse_id?: number, shipping_container_id?: number, transaction_id?: string, waveIds?: number[] }): Promise<{ reasons?: string[] }> 
  {
    let $url = `${environment.backendUrl}api/ProgrammableLogicController/functions/get_containers_ready_for_plc`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

